<div class="card">
  <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">
    <div class="w-full">
      <button
        class="button-elevation p-2 rounded-full"
        (click)="goBackToGame()"
      >
        Torna alla partita
      </button>
    </div>

    <div class="w-full shadow-medium p-4 rounded-3xl">
      <p class="text-2xl">Missione</p>
      <app-dynamic-form
        #myForm
        [options]="form2Opts"
        [fields]="regConfig2"
        (resetData)="initializeForm()"
        (onFormChange)="onFormChanges($event)"
        (submit)="submit($event)"
      >
      </app-dynamic-form>

      <div>
        <p class="text-lg">Tipologia di sblocco</p>
        <div
          class="flex justify-start items-center p-2 gap-6"
          style="max-width: 100%; overflow: scroll"
        >
          @for (unlockType of unlockTypes; track $index) {
            <div
              (click)="changeUnlockType(unlockType)"
              [class]="
                buttonClass +
                (selectedUnlockType == unlockType
                  ? ' bg-primary-500 text-black'
                  : ' bg-white/10')
              "
            >
              <i-tabler
                [name]="unlockTypeIcons[unlockType]"
                style="width: 1.5rem"
              ></i-tabler>
              <p class="">{{ unlockTypeLabels[unlockType] }}</p>
            </div>
          }
        </div>

        @switch (selectedUnlockType) {
          @case (unlockTypes[0]) {
            <div @slideDownUp class="p-2">
              Lo sblocco avverà immediatamente all'avvio della partita
            </div>
          }

          @case (unlockTypes[1]) {
            <p @slideDownUp class="p-2">
              Lo sblocco avverrà dopo
              <span @slideDownUp class="font-medium text-primary-500">{{
                formattedTime()
              }}</span>
              dall'inizio della partita
            </p>

            <div @slideDownUp class="w-1/2">
              <p>Tempo in secondi</p>
              <input
                type="text"
                [(ngModel)]="unlockTime"
                mask="0000"
                class="e-input"
              />
            </div>
          }

          <!-- --
          @case (unlockTypes[2]) {
            <p @slideDownUp class="p-2">
              Lo sblocco avverrà quando il giocatore si avvicinerà a
              <span class="font-medium text-primary-500">{{
                currentAddress
              }}</span>
            </p>

            <div @slideDownUp class="map-container flex flex-col gap-4">
              <div class="w-full my-2">
                <p>Indirizzo</p>
                <input
                  class="e-input"
                  type="text"
                  [(ngModel)]="currentAddress"
                  (ngModelChange)="onAddressChange()"
                />
              </div>
              <div class="flex flex-row gap-4 justify-center items-center">
                <div class="w-full">
                  <p>Latitudine</p>
                  <input
                    class="e-input"
                    type="text"
                    [(ngModel)]="latitudineInput"
                    placeholder="Es. 45.1335 oppure 45,1335"
                    (ngModelChange)="onLatitudeInputChange($event)"
                  />
                </div>
                <div class="w-full">
                  <p>Longitudine</p>
                  <input
                    class="e-input"
                    type="text"
                    [(ngModel)]="longitudineInput"
                    placeholder="Es. 9.1234 oppure 9,1234"
                    (ngModelChange)="onLongitudeInputChange($event)"
                  />
                </div>
                <div class="w-full">
                  <p>Range ({{ range / 1000 }} km)</p>
                  <input
                    class="e-input"
                    type="text"
                    suffix=" m"
                    mask="000000"
                    [(ngModel)]="range"
                    (ngModelChange)="updateRange()"
                  />
                </div>
              </div>

              <div
                leaflet
                [leafletOptions]="options"
                [leafletLayers]="layers"
                (leafletMapReady)="onMapReady($event)"
                (leafletDoubleClick)="onMapClick($event)"
                class="map"
              ></div>
            </div>
          }
          -->

          @case (unlockTypes[3]) {
            <p @slideDownUp class="p-2">
              Lo sblocco avverrà dopo la scansione del QR Code
            </p>
            @if(object?.qrCodes?.length){

              <div #qrContainer class="qr-display w-fit rounded-2xl p-2" style="background-color: #1e1e1e;" >
                @for (item of object?.qrCodes; track $index; let i = $index) {
                  <div class="qr-content flex flex-col items-center justify-center" style="background-color: #1e1e1e;">
                    <qrcode #qrComp [qrdata]="item.code" [width]="256" [errorCorrectionLevel]="'M'"
                            [colorDark]="'#F7F737'" [colorLight]="'#1e1e1e'" [elementType]="'canvas'">
                    </qrcode>

                    <div style="background-color: #1e1e1e;" class="code-text text-center"><b>{{ item.code }}</b></div>

                    <button type="button" [disabled]="loadingQrCode" class="btn button-elevation p-2 rounded-full my-2" (click)="downloadQR(i, item.code)">
                      <div>Scarica PNG</div>
                    </button>
                  </div>
                }
              </div>

            }@else{
              <p @slideDownUp class="p-2 text-red-500 font-bold">Il QR Code verrà generato in automatico dopo il salvataggio delle modifiche</p>


            }

<!--            <div @slideDownUp class="p-4 rounded-3xl shadow-small w-fit">-->
<!--              <qrcode-->
<!--                [qrdata]="object?.id ?? '?'"-->
<!--                [width]="256"-->
<!--                [errorCorrectionLevel]="'M'"-->
<!--              >-->
<!--              </qrcode>-->
<!--            </div>-->
          }
        }
      </div>
    </div>

    @if (object) {
      <div class="w-full shadow-medium p-4 rounded-3xl">
        <p class="text-2xl">Step</p>
        <app-gestione-step [idMission]="object.id"></app-gestione-step>
      </div>
    }

    <app-edit-history [data]="editHistoryData"></app-edit-history>
  </div>
</div>
